// src/google-maps/GoogleMapsApi.ts
var GoogleMapsApi = class {
  constructor() {
    this.autocompleteService = null;
    this.placesService = null;
    this.geocoder = null;
  }
  getAutocompleteService() {
    if (!this.autocompleteService && typeof window !== "undefined" && window.google?.maps?.places) {
      this.autocompleteService = new window.google.maps.places.AutocompleteService();
    }
    return this.autocompleteService;
  }
  getPlacesService() {
    if (!this.placesService && typeof window !== "undefined" && window.google?.maps?.places) {
      const dummyElement = document.createElement("div");
      this.placesService = new window.google.maps.places.PlacesService(dummyElement);
    }
    return this.placesService;
  }
  getGeocoder() {
    if (!this.geocoder && typeof window !== "undefined" && window.google?.maps) {
      this.geocoder = new window.google.maps.Geocoder();
    }
    return this.geocoder;
  }
  /**
   * Search for place predictions based on an input string.
   */
  searchPlaces(input) {
    return new Promise((resolve, reject) => {
      const service = this.getAutocompleteService();
      if (!service) {
        return reject(
          new Error(
            "Google Maps AutocompleteService is not initialized. Ensure the script is loaded with the places library."
          )
        );
      }
      if (!input) {
        return resolve([]);
      }
      service.getPlacePredictions(
        { input },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
            resolve(predictions);
          } else if (status === window.google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
            resolve([]);
          } else {
            reject(new Error(`Failed to fetch predictions: ${status}`));
          }
        }
      );
    });
  }
  /**
   * Get details of a specific place by its ID.
   */
  getPlaceDetails(placeId) {
    return new Promise((resolve, reject) => {
      const service = this.getPlacesService();
      if (!service) {
        return reject(
          new Error(
            "Google Maps PlacesService is not initialized. Ensure the script is loaded with the places library."
          )
        );
      }
      service.getDetails(
        { placeId },
        (place, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK && place) {
            resolve(place);
          } else {
            reject(new Error(`Failed to fetch place details: ${status}`));
          }
        }
      );
    });
  }
};
var googleMapsApi = new GoogleMapsApi();

export {
  GoogleMapsApi,
  googleMapsApi
};
